import * as React from "react";
import { Button } from "../../button";
import { Icon } from "../../icon";
import { apiCall } from "../../api/client";
import { schema } from "../../api/contracts/database/schema";

/**
 * "Back up now" — copies the live data.db to data.db.bak-<ISO> via the backup
 * route, then shows the destination path inline. Used on the Overview
 * connection card and surfaced as the first-write backup nudge.
 */
export function BackupButton({
  onDone,
  label = "Back up now",
  variant = "outline",
  size = "sm",
}: {
  onDone?: (path: string) => void;
  label?: string;
  variant?: React.ComponentProps<typeof Button>["variant"];
  size?: React.ComponentProps<typeof Button>["size"];
}) {
  const [busy, setBusy] = React.useState(false);
  const [done, setDone] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  async function run() {
    setBusy(true);
    setError(null);
    try {
      const res = await apiCall(schema.backup, {});
      setDone(res.path);
      onDone?.(res.path);
    } catch (e) {
      setError(e instanceof Error ? e.message : "backup failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-col gap-1">
      <Button variant={variant} size={size} onClick={run} disabled={busy}>
        <Icon name="hard-drive-download" size="sm" />
        {busy ? "Backing up…" : label}
      </Button>
      {done ? (
        <p className="type-subtext text-muted-foreground break-all">
          Backed up to <span className="text-foreground">{done}</span>
        </p>
      ) : null}
      {error ? <p className="type-subtext text-destructive">{error}</p> : null}
    </div>
  );
}
